<div class="content"> 
    <br>
     
  
    <h4  style="display:inline-block;">Drawings</h4>
    <button mat-raised-button (click)="openDrawingUpload()" style="margin-left: 20px;"><mat-icon class="mr">add</mat-icon>Add</button>
    <p>project-drawing works!</p>
</div>